import { UpdateOrderMemoRequest } from '@/coreInfrastructureModule/axios/generated/orderManage';

/**
 * 発注メモ更新情報へ変換する
 */
export class UpdateOrderMemoAdapter {
  /**
   * 変換する
   * @param memoText - メモの内容
   */
  public static adapt(memoText: string): UpdateOrderMemoRequest {
    return {
      orderMemoInfo: {
        orderMemo: memoText,
      },
    };
  }
}
